import { Component, Input } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { FormService } from '../../../common/services/form.service';
import { Field } from 'src/sb-tools/typescript/models/field.model';
import { ClientField } from '../../../common/models/client-field.model';
import { FocusDirective } from '@sb-tools/typescript/directives/focus.directive';
import { WhitespaceValidatorDirective } from '@form-field-module/common/directives/whitespace-validator.directive';
import { FormFieldLabelComponent } from '@form-field-module/common/components/form-field-label/form-field-label.component';

@Component({
    selector: 'sb-textarea',
    templateUrl: './textarea.component.html',
    styleUrls: ['./textarea.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    imports: [FormsModule, FocusDirective, WhitespaceValidatorDirective, FormFieldLabelComponent],
})
export class TextareaComponent {
    @Input() formField: Field | ClientField;

    placeholder: string;

    constructor(public formService: FormService) {}
}
